import * as types from './mutation-types';
import * as consts from '../data/base/consts'
import { API } from '../api';
import { UA } from '../utils';
import { CONFIG } from '../config';
import msg_srv from '../api/msg_srv'
import { MOMENT_TIME } from '../momenttime';
import { DATA, DISCUSS_DATA_MANAGER } from '../data';
import { FORMAT } from '../data/core/format';

export default {
    submitImport({ commit }, importParams) {
        commit(types.IMPORT_SUBMIT_IMPORT, importParams);
    },
    getBannerList({ state }){
        API.getBanner({}, (data)=>{
            state.bannerList = [].concat(data);
            console.log('getBanner-----', data, state.bannerList)
        })
    },
    initBasicData({ dispatch, state }, params) {
        if(!state.gotUserTypeData) {
            API.getUserType({}, function(data){
                console.log('初始化命局基础数据::::::::', data, state.gotUserTypeData)
                state.gotUserTypeData = true;
                dispatch('setting/initSettingData');
                dispatch('base/initSituationData', data.situation)
                dispatch('base/initStrongData', data.strong)
                dispatch('base/initMedicineData', data.medicine)
                dispatch('group/initGroupListData', data.group)
            })
        }
        if(!state.gotConfigJsonData) {
            API.getConfigJson({}, function(data) {
                console.log('获取json配置数据成功:::::::', data)
                state.gotConfigJsonData = true;
                state.configYiJiJsonData = data.yiji;
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            });
        }else {
            if(params && params.cb && typeof(params.cb) == 'function') {
                params.cb();
            }
        }
    },
    getUserLogin({state}, params) {
        API.userLogin({
            f_type: params.type,
            login_id: params.tel,
            pwd: params.password
        }, function(data) {
            console.log('用户手机登录成功:::::::', data)
            AppFate.$store.state.weblogin.showWebLogin = false;
            AppFate.$store.state.userData = data;
            window.sessionStorage.setItem("H5_Fate_UserInfo", JSON.stringify(data));
        }, function(data) {
            AppFate.$toast(msg_srv[data.status_code]);
        })
    },
    resetLoginCode({state}) {
        state.loginData.lockTime = consts.CONST_GET_CODE_TIME;
        state.loginData.lockCode = false;
        state.loginData.newMobile = '';
        state.loginData.lockTimeFunc = null;
        clearTimeout(state.loginData.lockTimeFunc);
    },
    getLoginCode({state}, params) {
        API.sendLoginCode({
            f_type: params.type,
            mobile: params.tel
        }, function(data) {
            console.log('用户手机获取验证码成功::::::::', data)
            state.loginData.lockCode = true;
            state.loginData.lockTimeFunc = function() {
                setTimeout(() => {
                    state.loginData.newMobile = params.tel;
                    state.loginData.lockTime--;
                    if(state.loginData.lockTime > 0) {
                        state.loginData.lockTimeFunc();
                    }else {
                        state.loginData.lockTime = consts.CONST_GET_CODE_TIME;
                        state.loginData.lockCode = false;
                        state.loginData.newMobile = '';
                        clearTimeout(state.loginData.lockTimeFunc);
                    }
                }, 1000);
            }
            state.loginData.lockTimeFunc();
    
            if(params.sucCb && typeof(params.sucCb) == 'function') {
                params.sucCb();
            }
        })
    },
    checkUserPwd({state}) {
        API.havepwd({}, function(data) {
            console.log('检查是否有密码成功:::::::', data)
            state.loginData.havePwd = data.have;
        })
    },
    getUserBind({state}, params) {
        API.bindUser({
            mobile: params.tel,
            code: params.code
        }, function(data) {
            console.log('绑定新的手机号码成功::::::::', data);
            state.loginData.lockTime = consts.CONST_GET_CODE_TIME;
            state.loginData.lockCode = false;
            state.loginData.newMobile = '';

            state.userData = Object.assign(data, {});
            if(UA.isAndroid() || CONFIG.platform == 'qq'){
                window.localStorage.removeItem("H5_Fate_TimeStamp");
                window.localStorage.setItem("H5_Fate_TimeStamp", (new Date()).getTime());
                window.localStorage.removeItem("H5_Fate_UserInfo");
                window.localStorage.setItem("H5_Fate_UserInfo", JSON.stringify(data));
            }else{
                window.sessionStorage.removeItem("H5_Fate_UserInfo");
                window.sessionStorage.setItem("H5_Fate_UserInfo", JSON.stringify(data));
            }

            if(params.sucCb && typeof(params.sucCb) == 'function') {
                params.sucCb();
            }
        }, function(data) {
            AppFate.$toast(msg_srv[data.status_code]);
        });
    },
    changePassword({state}, params) {
        API.changepwd({
            old: params.old,
            new: params.new
        }, function(data) {
            console.log('修改密码成功:::::::', data);
            // 清除数据
            // state.userData = {};
            // if(UA.isAndroid() || CONFIG.platform == 'qq'){
            //     window.localStorage.removeItem("H5_Fate_TimeStamp");
            //     window.localStorage.removeItem("H5_Fate_UserInfo");
            // }else{
            //     window.sessionStorage.removeItem("H5_Fate_UserInfo");
            // }
            if(params.sucCb && typeof(params.sucCb) == 'function') {
                params.sucCb();
            }
        }, function(data) {
            AppFate.$toast(msg_srv[data.status_code]);
        });
    },
    initTimeInputData({state}, params) {
        console.log('initTimeInputData----', params, state.timeInputData)
        let curTime = params && params.time ? params.time : MOMENT_TIME.getTimeStampByNow();
        let curTimeArr = MOMENT_TIME.getTimeArrayByTimeStamp(curTime*1000);
        state.timeInputData = Object.assign(state.timeInputData, {
            year: curTimeArr[0],
            month: curTimeArr[1],
            day: curTimeArr[2],
            hour: curTimeArr[3],
            minute: curTimeArr[4],
            isLunar: false
        })
        if(params.from == 'diagram') {
            let dateInfo = DATA.getTimeInfoByInputData(state.timeInputData, 'datestrtime');
            state.diagram.formData = Object.assign(state.diagram.formData, {
                d_time: curTime,
                d_timeStr: dateInfo[0]
            })
        }
    },
    resetTimeInputData({state}, params) {
        state.timeInputData = {
            "unknownTime": params && params.unknownTime ? params.unknownTime : false,
            "isLunar": params && params.isLunar ? params.isLunar : false,
            "year": '', 
            "month": '', 
            "day": '', 
            "hour": '', 
            "minute": ''
        }
    },
    getHomePageData({state}, params) {
        API.getHomePageData({}, function(data) {
            console.log('获取首页相关信息成功:::::::', data)
            // banner数据
            if(data && data.banner) {
                state.bannerList = [].concat(data.banner);
            }
            // 课程中心数据
            if(data && data.course) {
                state.homeCourseList = [].concat(data.course);
            }
            // 名人百科数据
            if(data && data.baike) {
                let baikeList = [].concat(data.baike);
                    baikeList.forEach((item)=>{
                        item.bzList = item.bz ? FORMAT.getEightWordArrBySzStr(item.bz) : [];
                    })
                console.log('baikeList----', baikeList);
                state.homeFamousPediaList = [].concat(data.baike);
            }
            // 热门论盘数据
            if(data && data.hot) {
                var result = DISCUSS_DATA_MANAGER.getLunPanMainListDataByData(data.hot.info, data.hot.userinfo);
                state.homeDiscussList = [].concat(result);
                console.log('homeDiscussList----', state.homeDiscussList);
            }
            if(params && params.sucCb && typeof(params.sucCb) == 'function') {
                params.sucCb(data);
            }
        })
    },
}